// src/mappings/componentsMapping.js
import Section1 from "../sections/Section1";
import Section2 from "../sections/Section2";
import Section3 from "../sections/Section3";
import Section4 from "../sections/Section4";
import Section5 from "../sections/Section5";
import Section6 from "../sections/Section6";
import Section12 from "../sections/Section12";
import Section13 from "../sections/Section13";
import Section14 from "../sections/Section14";
import Section15 from "../sections/Section15";

import Navbar from "../sections/Navbar";
import Distribuzione from "../sections/DistribuzioneOverview";
import GridCards from "../sections/GridCards";
import Form from "../sections/Form";
import Half_form from "../sections/Half_form";
import Insegne from "../sections/Insegne";
import Servizi from "../sections/Servizi";
import Images from "../sections/Images";
import Left_title from "../sections/Left_title";
import GridBlogs from "../sections/GridBlogs";
import CheckScontrino from "../sections/CheckScontrino";
import CheckOfferte from "../sections/CheckOfferte";
import Certificazioni from "../sections/Certificazioni";
import ImageDescription from "../sections/ImageDescription";
import Text from "../sections/Text";


const componentsMapping = {
  "section1.jsx": Section1,
  "section2.jsx": Section2,
  "section3.jsx": Section3,
  "section4.jsx": Section4,
  "section5.jsx": Section5,
  "section6.jsx": Section6,
  "section12.jsx": Section12,
  "section13.jsx": Section13,
  "section14.jsx": Section14,
  "section15.jsx": Section15,
  "Navbar.jsx": Navbar,
  "DistribuzioneOverview.jsx": Distribuzione,
  "GridCards.jsx": GridCards,
  "Form.jsx": Form,
  "Half_form.jsx": Half_form,
  "Insegne.jsx": Insegne,
  "Servizi.jsx": Servizi,
  "Images.jsx": Images,
  "Left_title.jsx": Left_title,
  "GridBlogs.jsx": GridBlogs,
  "GridBlogs.jsx": GridBlogs,
  "CheckScontrino.jsx": CheckScontrino,
  "Certificazioni.jsx": Certificazioni,
  "ImageDescription.jsx": ImageDescription,
  "CheckOfferte.jsx": CheckOfferte,
  "Text.jsx": Text,
};

export default componentsMapping;
